export const InlineWrapper = ({ children }, style = {}) => {
  return <div style={style}>{children}</div>;
};
